<template><div><h2 id="directives" tabindex="-1" class="d-docsite--header-2">Directives <a class="header-anchor d-link d-docsite--link d-link" href="#directives" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Behavioral plugins that attach to any element — add keyboard navigation, color modes, tooltips, and more.</p>
<table class="d-table dialtone-doc-table">
  <thead>
    <tr>
      <th>Directive</th>
      <th>Description</th>
      <th class="d-ta-right">Docs</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in directives" :key="item.name" valign="baseline">
      <th scope="row"><dt-text as="code" kind="code" size="100" class="d-docsite-code">{{ item.name }}</dt-text></th>
      <td>{{ item.description }}</td>
      <td class="d-ta-right"><dt-button kind="muted" importance="outlined" size="sm" target="_blank" :href="item.storybook"><template #startIcon="{ iconSize }"><dt-icon name="storybook-color" :size="iconSize" /></template>Storybook</dt-button></td>
    </tr>
  </tbody>
</table>
<h2 id="functions" tabindex="-1" class="d-docsite--header-2">Functions <a class="header-anchor d-link d-docsite--link d-link" href="#functions" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Stateless helpers for formatting and transforming data.</p>
<table class="d-table dialtone-doc-table">
  <thead>
    <tr>
      <th>Function</th>
      <th>Description</th>
      <th class="d-ta-right">Docs</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in functions" :key="item.name" valign="baseline">
      <th scope="row">{{ item.name }}</th>
      <td>{{ item.description }}</td>
      <td class="d-ta-right"><dt-button kind="muted" importance="outlined" size="sm" target="_blank" :href="item.storybook"><template #startIcon="{ iconSize }"><dt-icon name="storybook-color" :size="iconSize" /></template>Storybook</dt-button></td>
    </tr>
  </tbody>
</table>
<h2 id="utilities" tabindex="-1" class="d-docsite--header-2">Utilities <a class="header-anchor d-link d-docsite--link d-link" href="#utilities" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Foundational modules for rendering optimization and internationalization.</p>
<table class="d-table dialtone-doc-table">
  <thead>
    <tr>
      <th>Utility</th>
      <th>Description</th>
      <th class="d-ta-right">Docs</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in utilities" :key="item.name" valign="baseline">
      <th scope="row">{{ item.name }}</th>
      <td>{{ item.description }}</td>
      <td class="d-ta-right"><dt-button kind="muted" importance="outlined" size="sm" target="_blank" :href="item.storybook"><template #startIcon="{ iconSize }"><dt-icon name="storybook-color" :size="iconSize" /></template>Storybook</dt-button></td>
    </tr>
  </tbody>
</table>
</div></template>


<script setup>
import { directives, functions, utilities } from '@data/vue-utilities.json';
</script>